import { createUrl, getObject, getObjects, patchObject, postObject, putObject, REACT_APP_API_URL } from "../Common/js/api_common"

export const ENDPOINT_PLANTS = "/api/plants"

export async function getPlants(parameters = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PLANTS
  const defaultParameters = {}
  url = createUrl(url, parameters, defaultParameters)
  return await getObjects(url)
}

export async function getPlant(id) {
  let url = REACT_APP_API_URL + ENDPOINT_PLANTS + "/" + id
  return await getObject(url)
}

export async function putPlant(id, putValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PLANTS + "/" + id
  return await putObject(url, putValues)
}

export async function patchPlant(id, patchValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PLANTS + "/" + id
  return await patchObject(url, patchValues)
}

export async function postPlant(postValues = {}) {
  let url = REACT_APP_API_URL + ENDPOINT_PLANTS
  return await postObject(url, postValues)
}
